/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FastFolderTreeEntryInfo } from '../../models/fast-folder-tree-entry-info';

export interface FolderControllerFastListFolderTreeContent$Params {
  folderId: string;
}

export function folderControllerFastListFolderTreeContent(http: HttpClient, rootUrl: string, params: FolderControllerFastListFolderTreeContent$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FastFolderTreeEntryInfo>>> {
  const rb = new RequestBuilder(rootUrl, folderControllerFastListFolderTreeContent.PATH, 'get');
  if (params) {
    rb.path('folderId', params.folderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FastFolderTreeEntryInfo>>;
    })
  );
}

folderControllerFastListFolderTreeContent.PATH = '/folder/listFastTree/{folderId}';
